<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: $t('ETAB.PAGES.REVIEW.EXTRA.@TITLE', { name: review.getExtraFirstname() }),
      bgColor: 'primary',
      textColor: 'white',
    }"
    :card="{ class: 'bg-primary text-white' }"
    :body="{ class: 'text-center' }"
    :quasar-props="{ noBackdropDismiss: true }"
    size="lg"
  >
    <template #body>
      <section>
        <Avatar v-if="review.getPicture()" size="100px" :picture="review.getPicture()" />
        <h4>{{ review.getQualification() }}</h4>
        <div class="text-subtitle2">
          <p v-if="review.isAE()">
            {{ review.getDatesDisplay() }}
          </p>
          <p v-else>
            <template v-if="review.isOneDay()">
              {{ review.getDatesDisplay() }}
            </template>
            <template v-else>
              {{ startDateDisplay }}
              <QIcon name="icon-f-arrow-right" />
              {{ endDateDisplay }}
            </template>
          </p>
        </div>
      </section>

      <section>
        <h4>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@NOTE") }}</h4>
        <p>
          <QBtn
            v-for="star in MAX_NOTE"
            :key="star"
            icon="icon-extra-star"
            flat
            dense
            size="23px"
            :color="isSelected(star) ? 'yellowish' : 'primary-medium'"
            @click="onStarClick(star)"
          />
        </p>
      </section>

      <section>
        <h4>
          {{ $t("ETAB.PAGES.REVIEW.EXTRA.@COMMENT") }}
        </h4>

        <ExtraTextarea v-model="comment" :placeholder="$t('ETAB.PAGES.REVIEW.EXTRA.@PLACEHOLDER')" :limit="MEDIUM_TEXT_LENGTH_LIMIT" />
      </section>
    </template>
    <template #footer>
      <QBtn
        v-close-popup
        class="btn-navigation-half"
        color="white"
        flat
        :label="$t('ETAB.PAGES.REVIEW.EXTRA.@CANCEL')"
        no-caps
        @click="ignoreReview"
      />
      <QBtn
        v-close-popup
        :disabled="!isValid"
        class="btn-navigation-half"
        color="secondary"
        :label="$t('ETAB.PAGES.REVIEW.EXTRA.@ACTION')"
        no-caps
        @click="submitReview"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { StatusBar } from "@core/plugins/mobile";
  import { ReviewExtraModel } from "@core/models";
  import { MEDIUM_TEXT_LENGTH_LIMIT } from "@core/constants";
  import { ExtracadabraModal } from "@core/components/modals";

  const MAX_NOTE = 5;
  const DEFAULT_NOTE = 5;

  let statusbarDelay;

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      extraReview: {
        type: Object,
        default: () => new ReviewExtraModel(),
      },
    },
    emits: ["update:opened", "onSubmitReview", "onIgnoreReview"],
    data() {
      return {
        review: new ReviewExtraModel(),
        comment: "",
        note: DEFAULT_NOTE,
      };
    },
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
      startDateDisplay() {
        const dates = this.review.getDatesMoment();
        return dates.start.format("dddd DD MMM");
      },
      endDateDisplay() {
        const dates = this.review.getDatesMoment();
        return dates.end.format("dddd DD MMM");
      },
      isValid() {
        return this.comment.length <= MEDIUM_TEXT_LENGTH_LIMIT;
      },
    },
    watch: {
      opened(value) {
        this.resetModel();
        if (value === true) {
          // since the modal appears after an animation, we need to match the time of animation before changing color
          statusbarDelay = setTimeout(() => {
            // set statusbar to match modal background color
            StatusBar.setPrimaryBackground();
          }, 50);
        } else {
          // set statusbar back to default
          StatusBar.setDefault();
        }
      },
    },
    created() {
      this.MAX_NOTE = MAX_NOTE;
      this.MEDIUM_TEXT_LENGTH_LIMIT = MEDIUM_TEXT_LENGTH_LIMIT;
    },
    unmounted() {
      clearTimeout(statusbarDelay);
    },
    methods: {
      isSelected(star) {
        return star <= this.note;
      },
      onStarClick(star) {
        this.note = star;
      },
      resetModel() {
        this.review = new ReviewExtraModel(this.extraReview);
        this.comment = this.review.getComment();
        this.note = this.review.getNote() || DEFAULT_NOTE;
      },
      submitReview() {
        this.review.setComment(this.comment);
        this.review.setNote(this.note);
        this.$emit("onSubmitReview", { review: this.review });
      },
      ignoreReview() {
        this.$emit("onIgnoreReview", { review: this.review });
      },
    },
  };
</script>
